import type { LucideIcon, LucideProps } from 'lucide-react';

export interface IconProps extends Omit<LucideProps, 'ref'> {
  /** A lucide-react icon component, e.g. `CalendarCheck`. */
  readonly icon: LucideIcon;
  /** Pixel size; the design draws every icon at 16px unless stated. */
  readonly size?: number;
}

/**
 * Lucide icon in currentColor. The design draws lucide-static 0.454 glyphs as 16px CSS masks;
 * lucide-react renders the same glyphs, bundled (no CDN). Decorative by default.
 */
export function Icon({ icon: Glyph, size = 16, strokeWidth = 2, className, ...rest }: IconProps) {
  const labelled = rest['aria-label'] !== undefined;
  return (
    <Glyph
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className ? `flex-none ${className}` : 'flex-none'}
      aria-hidden={labelled ? undefined : true}
      focusable="false"
      {...rest}
    />
  );
}
